/**
 * A v4 UUID that never needs a secure context.
 *
 * `crypto.randomUUID` is secure-context-only: on the plain-http LAN origin used
 * for real-device testing `crypto` exists and the method does not, and calling
 * it unguarded throws. `getRandomValues` has no such restriction, so the
 * fallback composes v4 by hand from it.
 *
 * Lifted here for idempotency keys, which are minted per submission attempt
 * (a form mount), not per browser. `src/auth/deviceId.ts` keeps its own private
 * copy on purpose: its id means one browser, and it lives behind the auth
 * boundary.
 */
export function mintUuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  const hex = Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte, index) => {
    // Version 4 in the high nibble of byte 6, variant 10xx in byte 8.
    const value = index === 6 ? (byte & 0x0f) | 0x40 : index === 8 ? (byte & 0x3f) | 0x80 : byte
    return value.toString(16).padStart(2, '0')
  }).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
